class EventsCardGridV2 extends HTMLElement {
  constructor() {
    super();
    this.handle_click = this.handle_click.bind(this);
    this.handle_document_click = this.handle_document_click.bind(this);
    this.handle_scroll = this.handle_scroll.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handle_click);
    document.addEventListener('click', this.handle_document_click);
    window.addEventListener('scroll', this.handle_scroll, { passive: true });
    this.handle_scroll();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handle_click);
    document.removeEventListener('click', this.handle_document_click);
    window.removeEventListener('scroll', this.handle_scroll);
  }

  handle_document_click(event) {
    this.querySelectorAll('.events-card-grid-v2__booking-dates[open]').forEach((booking_dates) => {
      if (!booking_dates.contains(event.target)) {
        booking_dates.open = false;
      }
    });
  }

  handle_click(event) {
    const filter_button = event.target.closest('[data-events-card-v2-filter]');
    const scroll_link = event.target.closest('[data-events-card-v2-scroll]');
    const back_to_top_button = event.target.closest('[data-events-card-v2-back-to-top]');

    if (filter_button && this.contains(filter_button)) {
      this.filter_by_venue(filter_button);
      return;
    }

    if (scroll_link && this.contains(scroll_link)) {
      this.scroll_to_detail(event, scroll_link);
      return;
    }

    if (back_to_top_button && this.contains(back_to_top_button)) {
      this.scroll_to_top();
    }
  }

  filter_by_venue(filter_button) {
    const venue = filter_button.getAttribute('data-events-card-v2-filter') || 'all';
    const filter_buttons = this.querySelectorAll('[data-events-card-v2-filter]');
    const event_items = this.querySelectorAll('[data-events-card-v2-venue]');
    const empty_message = this.querySelector('[data-events-card-v2-empty-filtered]');
    let visible_count = 0;

    filter_buttons.forEach((button) => {
      const is_active = button === filter_button;

      button.classList.toggle('is-active', is_active);
      button.setAttribute('aria-pressed', is_active ? 'true' : 'false');
    });

    event_items.forEach((item) => {
      const item_venue = item.getAttribute('data-events-card-v2-venue');
      const should_show = venue === 'all' || item_venue === venue;

      item.hidden = !should_show;

      if (should_show && item.hasAttribute('data-events-card-v2')) {
        visible_count += 1;
      }
    });

    if (empty_message) {
      empty_message.hidden = visible_count > 0;
    }
  }

  scroll_to_detail(event, scroll_link) {
    const target_selector = scroll_link.getAttribute('href');

    if (!target_selector || !target_selector.startsWith('#')) {
      return;
    }

    const target_element = this.querySelector(target_selector);

    if (!target_element) {
      return;
    }

    event.preventDefault();

    target_element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });

    window.setTimeout(() => {
      target_element.focus({ preventScroll: true });
    }, 450);
  }

  scroll_to_top() {
    const target_element = this.querySelector('[data-events-card-v2-top]') || this;
    const target_top = target_element.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: target_top,
      behavior: 'smooth',
    });

    window.setTimeout(() => {
      target_element.focus({ preventScroll: true });
    }, 450);
  }

  handle_scroll() {
    const back_to_top_button = this.querySelector('[data-events-card-v2-back-to-top]');
    const section_rect = this.getBoundingClientRect();

    if (!back_to_top_button) {
      return;
    }

    const is_in_section = section_rect.top < 0 && section_rect.bottom > window.innerHeight;
    back_to_top_button.hidden = !is_in_section;
  }
}

if (!customElements.get('events-card-grid-v2')) {
  customElements.define('events-card-grid-v2', EventsCardGridV2);
}
